<template>
    <BreadCrumb PageTitle="Liste des Actualités" />
    <ListeActualite />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeActualite from "../../components/Actualite/ListeActualite.vue";
  
  export default defineComponent({
    name: "ListeActualitePage",
    components: {
      BreadCrumb,
      ListeActualite,
    },
  });
  </script>